import React from 'react'

function LastPrescriptionTab() {
  return (
    <div>LastPrescriptionTab</div>
  )
}

export default LastPrescriptionTab